import { Divider, Grid } from "@mui/material";
import AppDialog from "../../components/Common/AppDialog"
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { useState } from "react";
import CustomizedDatePicker from "../../components/Form/DatePicker";

const DateRangeModal = ({ open, close, value, startDate, endDate, handleSetDateRange }) => {
    const [isOpen, setIsOpen] = useState(true);
    return (
        <AppDialog
            open={open}
            close={close}
            title={'Custom dates'}
            width={'40%'}
            positiveTitle={'Save'}
            positivePress={() => {
                handleSetDateRange(value);
                close();
            }}
            cancelButton={true}
        >
            <div style={{ }}>
                <Grid container spacing={2} mb={2}>
                    <Grid item sm={6}>
                        <CustomizedDatePicker
                            title={'From'}
                            values={startDate && new Date(startDate)}
                            placeholder={"dd/mm/yyyy"}
                            setFormValues={(e) => handleSetDateRange([e, value ? value[1] : null])}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <CustomizedDatePicker
                            title={'To'}
                            values={endDate && new Date(endDate)}
                            placeholder={"dd/mm/yyyy"}
                            setFormValues={(e) => handleSetDateRange([value ? value[0] : null, e])}
                        />
                    </Grid>
                    <Grid item sm={12} xs={12} className="d-flex justify-content-center">
                        <DateRangePicker
                            onChange={(e) => handleSetDateRange(e)}
                            value={value === '' ? null : value}
                            sx={{
                                "& .MuiInput-root": {
                                    // Bottom border
                                    "&:before": {
                                        borderColor: "#96E6E9",
                                    },
                                },
                                zIndex: 99,
                                borderRadius: 12,
                            }}
                            calendarIcon={<i className="ri-calendar-line font-size-18" />}
                            isOpen={true}
                            closeCalendar={() => setIsOpen(false)}
                            shouldCloseCalendar={({ reason }) => {
                                if (reason === 'outsideAction' || reason === 'select') {
                                    setIsOpen(false);
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </div>
        </AppDialog>
    )
}
export default DateRangeModal;